export default __webpack_public_path__ + "static/media/ico-connect-xdefi.8b5a5566.svg";